import React from 'react'
import { IconButton } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import withPromise from 'helpers/withPromise'
import { ReactComponent as RemoveIcon } from 'assets/img/remove-button.svg'
import { ReactComponent as AddIcon } from 'assets/img/add-button.svg'
import { ReactComponent as AddWithDataIcon } from 'assets/img/add-with-data-button.svg'
import {
  ACTION_DUPLICATE,
  ACTION_DUPLICATE_WITH_DATA,
  DUPLICATE_INSERT_PARAMETER_AFTER,
} from 'constants/index'
import InputGroupInstructions from 'routes/App/Apps/MyJobs/JobTask/InputGroupInstructions'
import { embedableYoutubeVideo } from 'helpers/youtubeVideo'

function InputGroupItem({
  evtInputs,
  group,
  duplicateMatches,
  inputGroupIndex,
  duplicateInputGroup,
  deleteDuplicatedInputGroup,
  onJobTaskListRefresh,
  renderInput,
  onJobListRefresh,
  forceShowDuplicateControls = false,
}) {
  const {
    title,
    inputs,
    duplicable,
    id,
    original_input_group_id,
    instructions,
    video,
    image,
    preview_input_output,
  } = group

  const handleDuplicateInputGroup = (
    insert = DUPLICATE_INSERT_PARAMETER_AFTER,
    action = ACTION_DUPLICATE,
  ) => {
    withPromise(duplicateInputGroup, {
      id,
      action,
      data: {
        insert,
      },
    }).then(response => {
      if (!response.error) {
        onJobTaskListRefresh()
        onJobListRefresh(true)
      }
    })
  }

  const handleDeleteInputGroup = () => {
    const previewInputs = inputs
      .filter(({ preview }) => preview)
      .map(({ id }) => id)
    const previewsToRemove = evtInputs
      .filter(({ input }) => previewInputs.find(id => id === input))
      .map(({ id }) => id)

    withPromise(deleteDuplicatedInputGroup, {
      id,
      previewsToRemove,
    }).then(response => {
      if (!response.error) {
        onJobTaskListRefresh()
      }
    })
  }

  const hasPreviewOutput = Array.isArray(preview_input_output)
    ? preview_input_output.length > 0
    : false
  const showDuplicateControls = duplicable && !forceShowDuplicateControls

  const getPreviewLabel = ({ short_name, title: previewTitle }) => {
    const source = short_name || previewTitle || ''

    if (!source) {
      return ''
    }

    return source
      .toString()
      .replace(/_/g, ' ')
      .replace(/^\w/, char => char.toUpperCase())
  }

  return (
    <section className="input-group" key={id}>
      {!original_input_group_id && <div className="title">{title}</div>}
      <div className="input-container">
        {(instructions || embedableYoutubeVideo(video) || image) && (
          <InputGroupInstructions group={group} />
        )}
        {(!!duplicateMatches.length || !!original_input_group_id) && (
          <div className="input-group-index">{inputGroupIndex}</div>
        )}
        {hasPreviewOutput && (
          <div className="job-task-notification">
            <span className="job-task-notification-icon">i</span>
            {preview_input_output.map(
              ({ short_name, title: previewTitle, value }, index) => {
                const valueText =
                  !!value || value === false || value === 0
                    ? String(value).replace(/^\n+/, '')
                    : null
                // Actions always starts on a new line (even a single Farm/House entry).
                const isMultiline =
                  short_name === 'actions' ||
                  (typeof valueText === 'string' &&
                    (valueText.includes('\n') ||
                      valueText.trimStart().startsWith('- ')))

                return (
                  <div
                    key={`${short_name || previewTitle || 'preview'}-${index}`}
                    className="job-task-notification-title">
                    <strong>{`${getPreviewLabel({
                      short_name,
                      title: previewTitle,
                    })}:${isMultiline ? '' : ' '}`}</strong>
                    {valueText !== null && (
                      <span
                        className={
                          isMultiline
                            ? 'job-task-notification-value-multiline'
                            : undefined
                        }>
                        {valueText}
                      </span>
                    )}
                  </div>
                )
              },
            )}
          </div>
        )}
        {!!original_input_group_id && !forceShowDuplicateControls && (
          <IconButton
            size="small"
            className="remove-duplicate-button"
            onClick={handleDeleteInputGroup}>
            <RemoveIcon />
          </IconButton>
        )}
        {inputs.map(input => renderInput(input, group))}
      </div>
      {showDuplicateControls && (
        <div className="duplication-block">
          <IconButton
            size="small"
            className="duplicate-button"
            onClick={() => {
              handleDuplicateInputGroup(
                DUPLICATE_INSERT_PARAMETER_AFTER,
                ACTION_DUPLICATE_WITH_DATA,
              )
            }}>
            <AddWithDataIcon />
          </IconButton>
          <IconButton
            size="small"
            className="duplicate-button"
            onClick={() => {
              handleDuplicateInputGroup(
                DUPLICATE_INSERT_PARAMETER_AFTER,
                ACTION_DUPLICATE,
              )
            }}>
            <AddIcon />
          </IconButton>
        </div>
      )}
    </section>
  )
}

export default injectIntl(InputGroupItem)
